<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <router-link
            :to="{ name: 'reservationEvent' }"
            variant="relief-success"
            class="font-weight-bolder btn"
        >
          <b-button
          >
            رزروهای آنلاین تجربه
          </b-button>
        </router-link>
        <router-link
            :to="{ name: 'orderRequestEvent' }"
            variant="flat-secondary"
            class="font-weight-bolder btn"
        >
          <b-button

          >
            ایجاد سفارش
          </b-button>
        </router-link>
      </b-col>
    </b-row>
    <div v-if="orders">
      <div class="d-flex justify-content-between align-items-center">
        <per-page class="col-sm-12 col-md-3 col-lg-2" v-model="perPage"  />
        <!-- <search ref="ordersSearchComponent" class="w-50" v-model="searchInput" /> -->
      </div>

      <b-card body-class="p-0" class="mt-1">
        <table-head ref="ordersTableHeadComponent" :items="tableHeadings" @sort="sort" />
        <b-row
            class="py-1 mx-1 border-bottom"
            v-for="order in orders"
            :key="order.id"
        >
          <b-col class="d-flex align-items-center pl-0">
            {{ order.id }}
          </b-col>
          <b-col class="d-flex align-items-center pl-0">
            <div>
              <router-link
                  :to="{ name: 'eventsCalender', params: { id: order.experience.id } }"
                  variant="flat-secondary"
                  class="font-weight-bolder btn"
              >
                <BIconCalendar />
              </router-link>
            </div>
            <b-badge variant="info">
              {{ order.experience.code }}
            </b-badge>
            <a target="_blank"  :href="'https://roomtoor.com/event/' + order.experience.category.slug+'-'+ order.experience.code">
              {{order.experience.name }}
            </a>
          </b-col>
          <b-col class="d-flex align-items-center pl-0">
            <div>

              <span>
            {{ order.experience.host.full_name }}
                    </span>
              <br/>
              <b-badge variant="primary" v-if="order.experience.host.mobile">
                {{ order.experience.host.mobile.replace("+98","0") }}
              </b-badge>
              <div class="mt-1">
                <strong style="background: yellow">سانس/تیکت:</strong>
                <span v-for="(sans,s) in order.experience.experience_dates" :key="s">
                        <span v-if="sans.id===order.ticket_id" >
                              {{sans.name}}
                        </span>
                     </span>
              </div>
            </div>
          </b-col>
          <b-col class="d-flex align-items-center pl-0">
            <div>
                <span>
                {{ order.user.first_name+' '+order.user.last_name }}
              </span>
              <br/>
              <b-badge variant="primary">
                {{ order.user.mobile.replace("+98","0") }}
              </b-badge>
            </div>
          </b-col>

          <b-col class="d-flex align-items-center pl-0">
            <div>
              <span>تاریخ رزرو  : </span>
              <b-badge variant="info" v-if="order.checkin">
                {{ new Date(order.checkin).toLocaleString('fa-IR').split(",")[0]}}
              </b-badge>
              <br/>
              <span>تعداد مهمان ها : </span>
              <b-badge variant="info" v-if="order.guests.adult >0">
                {{ order.guests.adult }} نفر بزرگسال
              </b-badge>
              <b-badge variant="info" style="margin: 0 2px" v-if="order.guests.child >0">
                {{ order.guests.child }} نفر کودک
              </b-badge>
              <b-badge variant="info" v-if="order.guests.baby >0">
                {{ order.guests.baby }} نفر نوزاد
              </b-badge>
              <b-badge variant="info" style="margin: 0 2px" v-if="order.guests.pet >0">
                {{ order.guests.pet }} حیوان
              </b-badge>
              <br/>
              <span>هزینه پرداختی : </span>
              <b-badge variant="info" class="my-1">
                {{ numberFormat(order.prices.final_price) }} تومان
              </b-badge>
              <br/>
              <span>کمیسیون سایت  : </span>
              <b-badge variant="dark" v-if="order.prices.total_commission_host_roomtoor">
                <!--                {{ formatnumber(transaction.commission_price)}} تومان-->
                {{ numberFormat(order.prices.total_commission_host_roomtoor) }} تومان
              </b-badge>
              <b-badge variant="dark" v-if="order.prices.total_commission_site_roomtoor">
                <!--                {{ formatnumber(transaction.commission_price)}} تومان-->
                {{ numberFormat(order.prices.total_commission_site_roomtoor) }} تومان
              </b-badge>
              <br />
              <span>کمیسیون دریافتی میزبان  : </span>
              <b-badge variant="dark" v-if="order.prices.total_pay_host_commission_host">
                <!--                {{ formatnumber(transaction.commission_price)}} تومان-->
                {{ numberFormat(order.prices.total_pay_host_commission_host) }} تومان
              </b-badge>
              <b-badge variant="dark" v-if="order.prices.total_pay_host_commission_site">
                <!--                {{ formatnumber(transaction.commission_price)}} تومان-->
                {{ numberFormat(order.prices.total_pay_host_commission_site) }} تومان
              </b-badge>
            </div>
          </b-col>

          <b-col
              class="d-flex align-items-center flex-row-reverse"
              style="direction: ltr"
          >
            {{ new Date(order.created_at).toLocaleString('fa-IR', { timeZone: 'Iran' })}}
          </b-col>
          <b-col class="d-flex align-items-center pl-0">
            <!--            <b-badge variant="dark"  class="badge-glow" v-if="order.status==='ready_to_pay'">
                          میزبان تایید کرد
                        </b-badge>-->
            <b-badge variant="warning"  class="badge-glow" v-if="order.status==='pending'">
              در انتظار میزبان
            </b-badge>
            <b-badge variant="warning"  class="badge-glow" v-if="order.status==='ready_to_pay'">
              سفارش قبل از درگاه
            </b-badge>
            <b-badge variant="success"  class="badge-glow" v-if="order.status==='paid'">
              مهمان پرداخته
            </b-badge>
            <!--            <b-badge variant="danger"  class="badge-glow" v-if="order.status==='canceled'">
                          کنسل
                        </b-badge>
                        <b-badge variant="danger"  class="badge-glow" v-if="order.status==='rejected'">
                          رد داده
                        </b-badge>-->
          </b-col>
          <b-col class="d-flex align-items-center">
                        <b-button
                          @click="showConfirmModal(order)"
                          variant="flat-danger"
                          class="font-weight-bolder"
                        >
                          <feather-icon icon="Trash2Icon" size="20" />
                        </b-button>
            <b-button
                @click="showFormModal(order)"
                variant="flat-secondary"
                class="font-weight-bolder"
            >
              <feather-icon icon="Edit2Icon" size="20" />
            </b-button>
          </b-col>
        </b-row>
      </b-card>
      <pagination ref="ordersPaginationComponent" v-model="page" :paginationData="paginationData" />
    </div>
    <b-sidebar
        width="570px"
        v-model="formModal"
        right
        backdrop
        shadow
        bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
                style="background-color: rgba(75, 75, 75, 0.12)"
                @click="formModal = false"
                variant="flat-dark"
                class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش سفارش" : "ایجاد سفارش" }}
            </h3>
          </div>
        </div>
      </template>
      <b-container class="">
        <b-row>
          <b-col class="col-12 col-md-12">
            <b-form-group>
              <div>
                <strong>  pending :</strong>
                حالتی که مهمان منتظر تایید کنه
              </div>
              <div>
                <strong>  ready_to_pay :</strong>
                حالتی که مهمان رفته به مرحله بعد و مشاهده فاکتور
              </div>
              <div>
                <strong>  paid :</strong>
                حالتی که مهمان پرداخت کرده
              </div>
              <label for="residence_area" class="text-capitalize">
                وضعیت پرداخت:<span class="text-danger">*</span>
              </label>
              <v-select
                  id="residence_area"
                  :components="{ OpenIndicator }"
                  class="bg-white"
                  :clearable="false"
                  v-model="orderInput.status"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="statusPayment"
              />
            </b-form-group>
          </b-col>
          <b-col class="col-12 col-md-12">
            <b-form-group>
              <label for="name" class="text-capitalize">* تاریخ رزرو : </label>
              <b-form-input class="my-custom-editable-input1" type="text" />
              <date-picker
                  auto-submit
                  clearable
                  format="YYYY-MM-DD"
                  display-format="jYYYY-jMM-jDD"
                  v-model="orderInput.checkin"
                  custom-input=".my-custom-editable-input1"
              />
            </b-form-group>
          </b-col>
          <b-form-group  class="col-md-3">
            <label for="adult" class="text-capitalize"
            > تعداد نفرات بزرگسال<span class="text-danger">*</span></label
            >
            <b-form-input
                lazy
                type="number"
                v-model="orderInput.guests.adult"
                id="adult"
                key="adult"
                placeholder="  تعداد نفرات بزرگسال"
            />
          </b-form-group>
          <b-form-group  class="col-md-3">
            <label for="child" class="text-capitalize"
            > تعداد نفرات کودک<span class="text-danger">*</span></label
            >
            <b-form-input
                lazy
                type="number"
                v-model="orderInput.guests.child"
                id="child"
                key="child"
                placeholder="  تعداد نفرات کودک"
            />
          </b-form-group>
          <b-form-group class="col-md-3">
            <label for="baby" class="text-capitalize"
            > تعداد نوزاد<span class="text-danger">*</span></label
            >
            <b-form-input
                lazy
                type="number"
                v-model="orderInput.guests.baby"
                id="baby"
                key="baby"
                placeholder="  تعداد نفرات نوزاد"
            />
          </b-form-group>
          <b-form-group class="col-md-3">
            <label for="adult" class="text-capitalize"
            > تعداد نفرات حیوان<span class="text-danger">*</span></label
            >
            <b-form-input
                lazy
                type="number"
                v-model="orderInput.guests.pet"
                id="adult"
                key="adult"
                placeholder="  تعداد نفرات حیوان"
            />
          </b-form-group>

          <b-col class="col-12 col-md-12">
            <div>ویرایش کردن قیمت ها</div>
          </b-col>
          <b-form-group class="col-md-12">
            <label for="adult" class="text-capitalize"
            >
              هزینه پرداختی به سایت
              :
            </label>
            {{numberFormat(orderInput.prices.final_price)}}
            تومان
            <b-form-input
                lazy
                type="number"
                v-model="orderInput.prices.final_price"
                id="adult"
                key="adult"
                placeholder="  کمیسیون دریافتی سایت "
            />
          </b-form-group>
          <b-form-group class="col-md-12">
            <label for="adult" class="text-capitalize"
            >
              کمیسون دریافتی سایت
              :
            </label>
            {{numberFormat(orderInput.prices.total_commission_host_roomtoor)}}
            تومان
            <b-form-input
                lazy
                type="number"
                v-model="orderInput.prices.total_commission_host_roomtoor"
                id="adult"
                key="adult"
                placeholder="  کمیسیون دریافتی سایت "
            />
          </b-form-group>
          <b-form-group class="col-md-12">
            <label for="adult" class="text-capitalize"
            >
              کمیسون دریافتی میزبان
              :
            </label>
            {{numberFormat(orderInput.prices.total_pay_host_commission_host)}}
            تومان
            <b-form-input
                lazy
                type="number"
                v-model="orderInput.prices.total_pay_host_commission_host"
                placeholder="  کمیسیون دریافتی میزبان "
            />
          </b-form-group>
        </b-row>

      </b-container>
      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
              class="text-capitalize mr-2"
              @click="formModal = false"
              variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormRadio, BBadge, BIconCalendar, BIconChatRightTextFill,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {
    BIconChatRightTextFill,
    BIconCalendar,
    BBadge,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BFormRadio,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      perPage: 10,
      page: 1,
      orders: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      statusPayment:[
        "pending",
        "ready_to_pay",
        "paid"
      ],
      tableHeadings: [
        {
          title: "شماره رزرو",
          slug: "name",
          sortable: true,
        },
        {
          title: "عنوان",
          slug: "name",
          sortable: true,
        },
        {
          title: "میزبان",
          slug: "host",
          sortable: true,
        },
        {
          title: "مهمان",
          slug: "guest",
          sortable: true,
        },
        {
          title: "سفارش",
          slug: "order",
          sortable: true,
        },
        {
          title: "تاریخ درخواست",
          slug: "created_at",
          sortable: true,
        },
        {
          title: "وضعیت پرداخت",
          slug: "status",
          sortable: false,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },

      orderInput: {
        name: "",
        slug:"",
        checkin:"",
        prices:"",
        guests:"",
        status:""

      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getCounties();
    // this.getCompanies();
  },
  watch: {
    searchInput(value) {
      this.page = 1;
      this.getCounties();
    },
    perPage(value) {
      this.page = 1;
      this.getCounties();
    },
    page(value) {
      this.getCounties();
    },
  },
  methods: {
    numberFormat(number) {
      return  new Intl.NumberFormat().format(number)
    },


    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getCounties();
    },

    async getCounties() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        paginate:true,
        //  this.searchInput,
        // per_page: this.perPage,
        page: this.page,
        orderable_type:'experience',
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/orders?orderable_type=experience",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.orders = data.data;
            this.paginationData = data.meta;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    showConfirmModal(order) {
      this.$bvModal
          .msgBoxConfirm(
              "آیا از حذف سفارش مطمئن هستید ؟" +
              `: ${order.name}.`,
              {
                title: this.$t("Please Confirm"),
                size: "sm",
                okVariant: "primary",
                okTitle: this.$t("Yes"),
                cancelTitle: this.$t("No"),
                cancelVariant: "outline-secondary",
                hideHeaderClose: false,
                centered: true,
              }
          )
          .then(async (confirmed) => {
            if (confirmed) {
              let orderIndex = 0;
              this.orders = await this.orders.filter((orderItem, index) => {
                if (orderItem.id == order.id) {
                  orderIndex = index;
                }
                return orderItem.id !== order.id;
              });

              const requestData = {
                method: "delete",
                url: `/admin/orders/${order.id}`,
              };
              this.$http(requestData)
                  .then((response) => {
                    this.$bvToast.toast(
                        `سفارش: ${order.name} با موفقیت حذف شد.`,
                        {
                          title: this.$t("Done"),
                          variant: "success",
                          solid: true,
                        }
                    );
                  })
                  .catch((err) => {
                    let message = this.$t("Unable to delete!");
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.message
                    )
                      message = err.response.data.message;
                    this.$bvToast.toast(message, {
                      title: this.$t("Error"),
                      variant: "danger",
                      solid: true,
                    });
                    this.orders.splice(orderIndex, 0, order);
                  });
            }
          });
    },
    showFormModal(order) {
      if (order) {
        this.orderInput = {
          id: order.id,
          name: order.name,
          slug:order.slug,
          status:order.status,
          prices:order.prices,
          guests:order.guests,
          checkin:order.checkin,

        };
        this.editMode = true;
      } else {
        this.orderInput = {
          name: "",
          slug:"",
          checkin:"",
          status:"active",

        };
        this.editMode = false;
      }
      this.formModal = true;
    },
    submitForm() {
      if (this.submitLoading) return;
      /*
            let errorMessage = null;

            if (!errorMessage && !this.orderInput.name) {
              errorMessage = "لطفا نام سفارش را وارد کنید";
            }
            if (!errorMessage && this.orderInput.name.length < 2) {
              errorMessage = "نام سفارش نمی تواند کمتر از دو کاراکتر باشد";
            }
            if (!errorMessage && !this.orderInput.slug) {
              errorMessage = "لطفا اسلاگ سفارش را وارد کنید";
            }
             if (!errorMessage && this.orderInput.slug.length < 2) {
              errorMessage = "اسلاگ سفارش نمی تواند کمتر از دو کاراکتر باشد";
            }


            if (errorMessage) {
              this.$bvToast.toast(errorMessage, {
                title: this.$t("Error"),
                variant: "danger",
                solid: true,
              });
              return;
            }
      */

      this.submitLoading = true;

      const requestData = {
        method: this.editMode ? "put" : "post",
        url: this.editMode ? `/admin/orders/${this.orderInput.id}` : `/admin/orders`,
        data: this.orderInput,
      };

      this.$http(requestData)
          .then((response) => {
            let message = "سفارش با موفقیت اضافه شد";
            if (this.editMode) message = "سفارش با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
            /*     if (!this.editMode && this.orders && this.orders.length > 0) {
                   this.$refs.ordersPaginationComponent.clear();
                   // this.$refs.ordersSearchComponent.clear();
                   this.$refs.ordersTableHeadComponent.clear();
                   this.page = 1;
                   this.searchInput = "";
                   this.sortBy = "";
                   this.sortDir = "";
                 }*/

            this.submitLoading = false;
            this.formModal = false;
            this.getCounties();
          })
          .catch((err) => {
            let message = "خطا در ایجاد سفارش";
            if (this.editMode) message = "خطا در ویرایش سفارش";
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });
    },


  },

  computed:{
    hostMobile() {
      if (this.order && this.order.experience && this.order.experience.host && this.order.experience.host.mobile) {
        return this.order.experience.host.mobile.replace("+98","0");
      }
      return ""; // or some default value
    }
  }
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
